import { render, staticRenderFns } from "./CallControls.vue?vue&type=template&id=3a983550&scoped=true&"
import script from "./CallControls.vue?vue&type=script&lang=js&"
export * from "./CallControls.vue?vue&type=script&lang=js&"
import style0 from "./CallControls.vue?vue&type=style&index=0&id=3a983550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a983550",
  null
  
)

export default component.exports